import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AutorizationGuard } from './guards/authorization.guards'
import { LoraRootComponent } from './lora-root.component';
import { LoginComponent } from './pages/login/login.component';
import { DeviceInfoPageComponent } from './pages/device-info/divice-info.component';
import { DeviceConfigPageComponent } from './pages/device-config/device-config.componenta';
import { DeviceListComponent } from './pages/devices-list/devices-list.component';
import { DevicesServicesComponent } from './pages/devices-services/devices-services.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { BlockUIComponent } from './components/block/block-ui.component'
import { AlertUIComponent } from './components/alert/alert.component'
import { TableUIComponent } from './components/table/table-ui.component'
import { StickBlockUIComponent } from './components/stiks/stick.component'
import { GraphicUIComponent } from './components/graphic/graphic-ui.component';
import { CheckBoxUiComponentUIComponent } from './components/checkbox/checkbox-ui.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChartsModule } from 'ng2-charts';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgxMaskModule } from 'ngx-mask'
import { HttpServices } from './services/http-services';
import { AuthenticationService } from './services/authentication-services';
import { Constants } from './services/constants-service';
import { ErrorHandlerService } from './services/error.handler.service';
import { AlertService } from './services/alert.service';
import { PrintTableService } from './services/printTableService';
import { MyDatePickerModule } from 'mydatepicker';
import { AlertModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { Interceptor } from './services/interceptor.service';
import { TokensService } from './services/tokens.service';
import { DetectedCoreHostService } from './services/detected.core.host.service';

@NgModule({
    imports: [BrowserModule,
              HttpClientModule,
              BrowserAnimationsModule,
              ChartsModule,
              FormsModule,
              ReactiveFormsModule,
              Ng2SmartTableModule,
              NgxMaskModule.forRoot(),
              AlertModule.forRoot(),
              BsDropdownModule.forRoot(),
              MyDatePickerModule,
              AngularFontAwesomeModule,
              MultiselectDropdownModule,
              RouterModule.forRoot([
                  { path: 'login', component: LoginComponent},
                  { path: 'device-list', component: DeviceListComponent,  canActivate: [AutorizationGuard]},
                  { path: 'device-info', component: DeviceInfoPageComponent,  canActivate: [AutorizationGuard]},
                  { path: 'device-config', component: DeviceConfigPageComponent,  canActivate: [AutorizationGuard]} ,
                  { path: 'devices-services', component: DevicesServicesComponent,  canActivate: [AutorizationGuard]} ,
                  { path: '', redirectTo: 'device-list', pathMatch: 'full'}
                  ])
              ],
    providers: [
      HttpServices,
      Constants,
      AutorizationGuard,
      AuthenticationService,
      TokensService,
      ErrorHandlerService,
      AlertService,
      PrintTableService,
      DetectedCoreHostService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: Interceptor,
        multi: true
      }],
    declarations: [LoraRootComponent,
                   LoginComponent,
                   FooterComponent,
                   HeaderComponent,
                   BlockUIComponent,
                   AlertUIComponent,
                   CheckBoxUiComponentUIComponent,
                   TableUIComponent,
                   StickBlockUIComponent,
                   GraphicUIComponent,
                   DeviceListComponent,
                   DeviceInfoPageComponent,
                   DeviceConfigPageComponent,
                   DevicesServicesComponent],
    bootstrap: [LoraRootComponent]
})
export class LoraRootModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/lora-root.module.ts